// import Vue from 'vue'
// import Vuex from 'vuex'
// Vue.use(Vuex);
// // import mutations from './mutations'
// // import actions from './actions'

// export default new Vuex.Store({
// });

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    head:false,
    count: 0,
    messageNum: '',
    cartNum: '',
    login:JSON.parse(sessionStorage.getItem("userInfo")) || {}
  },
  mutations: {
    loginData(state,option){
      sessionStorage.setItem("userInfo",JSON.stringify(option))
      state.login = option
    },
    messageNumChange(state, num) {
      state.messageNum = num
    },
    cartNumChange(state, num) {
      state.cartNum = num
    },
    increment (state,number) {
      state.count += number
    }
  }
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js